import AmioHttpService from './amio-http.service'

class MultiBotService extends AmioHttpService {

  createFromTemplate(botName, template, variantName, timezone, type, language, marketId) {
    const primaryVariant = {
      name: variantName,
      nlp_model_type: 'gpt',
      market_id: marketId,
      template,
      timezone,
      type,
      language
    }
    const payload = {
      name: botName,
      primary_variant: primaryVariant
    }
    return this.requestPost('/multi-bots', payload)
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  updateName(multiBotId, name) {
    return this.requestPatch(`/multi-bots/${multiBotId}`, { name })
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  list() {
    return this.requestGet('/multi-bots')
      .then(response => response.data)
      .then(multiBots => multiBots.map(adapt))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  createVariant(multiBotId, name, timezone, language, marketId) {
    return this.requestPost(`/multi-bots/${multiBotId}/variants`, {
      name,
      timezone,
      language,
      market_id: marketId,
      nlp_model_type: 'gpt'
    })
      // The entity is created synchronously; response is the variant multi-bot shape with a
      // `progress: { jobId, status }` field. The variant botId is `primary_bot_id`.
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  getVariantProgress(multiBotId, botId) {
    return this.requestGet(`/multi-bots/${multiBotId}/variants/${botId}/progress`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  delete(multiBotId) {
    return this.requestDelete(`/multi-bots/${multiBotId}`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  deleteVariant(multiBotId, botId) {
    return this.requestDelete(`/multi-bots/${multiBotId}/variants/${botId}`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

}

function adapt(multiBot) {
  return {
    id: multiBot.id,
    name: multiBot.name,
    isPrimaryVariant: multiBot.is_primary_variant,
    primaryBotId: multiBot.primary_bot_id,
    primaryBot: multiBot.primary_bot
  }
}

export default new MultiBotService()
